import { render, staticRenderFns } from "./VideoThumbnailModal.vue?vue&type=template&id=8d747b4e&scoped=true"
import script from "./VideoThumbnailModal.vue?vue&type=script&lang=ts"
export * from "./VideoThumbnailModal.vue?vue&type=script&lang=ts"
import style0 from "./VideoThumbnailModal.vue?vue&type=style&index=0&id=8d747b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d747b4e",
  null
  
)

export default component.exports